<template>
    <section class="building-meta container">
        <div class="architect" v-if="site?.fields['Architect']">
            <p class="body-book heavy">Architect</p>
            <p class="body-book">{{ site.fields['Architect'] }}</p>
        </div>

        <div class="year-completed" v-if="site?.fields['Building Year']">
            <p class="body-book heavy">Year Completed</p>
            <p class="body-book">{{ site?.fields['Building Year'] }}</p>
        </div>
        <div class="years" v-if="years">
            <p class="body-book heavy">OHC Appearances</p>
            <p class="body-book">{{ years }}</p>
        </div>
    </section>
</template>

<script setup>
    const props = defineProps({
        site: {
            type: Object,
            required: true,
        },
    });

    const { site } = toRefs(props);

    const years = computed(() => {
        if (site) {
            const field = site.value.fields['OHC Years of Participation'];
            if (field && field.length) {
                return field.join(', ');
            } else {
                return 'New';
            }
        }
    });
</script>

<style lang="scss">
    .building-meta {
        margin-top: 40px;
        display: grid;
        grid-template-columns: repeat(2, minmax(0, 1fr));
        grid-gap: 20px;

        @media (min-width: $tablet) {
            max-width: 65%;
        }

        .small-heavy {
            text-transform: uppercase;
        }
        .body-book.heavy,
        .small-book.heavy {
            font-weight: 800;
        }
    }
</style>
